import { api } from './client';
import type {
  Category,
  CategoryCreateRequest,
  CategoryUpdateRequest,
} from '../types';

export const categoriesApi = {
  list: (params: { storeId?: number | null; activeOnly?: boolean } = {}) =>
    api
      .get<Category[]>('/categories', {
        params: {
          storeId: params.storeId ?? undefined,
          activeOnly: params.activeOnly ?? false,
        },
      })
      .then((r) => r.data),

  create: (body: CategoryCreateRequest) =>
    api.post<Category>('/categories', body).then((r) => r.data),

  update: (id: number, body: CategoryUpdateRequest) =>
    api.put<Category>(`/categories/${id}`, body).then((r) => r.data),

  deactivate: (id: number) =>
    api.delete<void>(`/categories/${id}`).then((r) => r.data),
};
